module.exports = __webpack_public_path__ + "media/images/logo-2f13f0871cd20a3863f1ab304adc37af.png";